import { merge } from "lodash";
import getParent from "../../utils/getParent";
import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { MutiMng } from "./expose";
import { getFilter } from "./get";

const ContainerMng = new MutiMng({
  key: "people_source",
  dataKey: "people_id",
  reporterKeys: {
    ids: "people_ids",
    number: "people_number",
  },
});

export function people_expose(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 36001,
    event_name: "people_expose",
    people_id: targetNode.getAttribute("data-people-id"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    trackData.people_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.people_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  if (page_nm === "专题页") {
    const el = document.querySelector("[data-topic-id]");
    if (el) {
      trackData.topic_title = el.getAttribute("data-topic-title");
      trackData.topic_id = el.getAttribute("data-topic-id");
    }
  }

  merge(trackData, getFilter(page.page_nm, targetNode));

  ContainerMng.add(trackData);
}

export function people_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 36002,
    event_name: "people_click",
    people_id: targetNode.getAttribute("data-people-id"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");
  if (sourceNode) {
    trackData.people_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.people_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  merge(trackData, getFilter(page.page_nm, targetNode));

  reporter(trackData);
}
